// File: RedirectToPrevious.js
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const RedirectToPrevious = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // If there's a state with a "from" field, go back to that
    if (location.state?.from) {
      navigate(location.state.from, { replace: true });
    } else {
      // Else, go to default route
      navigate("/error_404", {
        replace: true,
      });
    }
  }, [navigate, location]);

  return null;
};

export default RedirectToPrevious;
